import React, {Component} from 'react'
import Dialog from 'material-ui/Dialog'
import './css/index.css'
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import PropTypes from 'prop-types'
import {app} from "../../../../../../config/constants"
import {connect} from 'react-redux'
import {
	loadImages,
	resetImages,
	addTempImage,
	updateTempImage,
	removeTempImage
} from "../../../../../../api/images";


class FileDropZoneDialog extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: {
				open: false
			},
			acceptedFileTypes: this.props.acceptedFileTypes ||
			[
				'image/jpeg',
				'image/png',
				'image/bmp',
				'image/gif',
			],
			acceptedFiles: [],
			rejectedFiles: [],
			uploadedFiles: [],
			items: [],
			selectedImage: {},
			errors: [],
		};

		this.onDragOver = this.onDragOver.bind(this);
		this.onDrop = this.onDrop.bind(this);
		this.onDragLeave = this.onDragLeave.bind(this);
		this.openModal = this.openModal.bind(this);
		this.selectImage = this.selectImage.bind(this);
		this.rejectFile = this.rejectFile.bind(this);
		this.removeErrors = this.removeErrors.bind( this );
	};

	rejectFile( filename, error, tempImageId ) {
		this.setState({
			...this.state,
			errors: [
				...this.state.errors,
				{
					fileName: filename,
					message: error
				}
			]
		});

		removeTempImage({
			id: tempImageId
		});
	}

	removeErrors() {
		this.setState({
			...this.state,
			errors: [],
		});
	}

	handleClose = () => {
		this.setState({
			...this.state,
			modal: {
				...this.state.modal,
				open: false
			}
		})
	};

	openModal = (event) => {
		event.preventDefault();

		this.setState({
			...this.state,
			modal: {
				...this.state.modal,
				open: true
			}
		})
	};


	onDragOver = (event) => {
		event.dataTransfer.dropEffect = 'copy';

		document.getElementById('FileDropZoneDialogDropZone').classList.add('active');

		event.preventDefault();
		event.stopPropagation();
	};

	onDragLeave = (event) => {

		document.getElementById('FileDropZoneDialogDropZone').classList.remove('active');

		event.preventDefault();
		event.stopPropagation();
	};

	onDrop = (event) => {
		const {upload, promotionType} = this.props;
		const acceptedFiles = [];
		const rejectedFiles = [];

		document.getElementById('FileDropZoneDialogDropZone').classList.remove('active');

		event.preventDefault();
		event.stopPropagation();

		const files = event.dataTransfer;

		if (files.items) {
			for (const item of files.items) {
				const file = item.getAsFile();
				const microtime = new Date().getTime();

				const _URL = window.URL || window.webkitURL;

				const img = new Image();

				if( file ) {
					img.src = _URL.createObjectURL( file );
				}
				else {
					img.src = event.dataTransfer.getData("Text");
				}

				img.onload = () => {
					addTempImage({id: microtime});


					// console.log( file.getData() );

					const storageRef = app.storage().ref();
					const imageRef = storageRef.child('cams/' + promotionType + '/' + file.name);


					imageRef.getDownloadURL().then( () => {
						// If exists, don't do anything with it, send it to rejected files
						this.rejectFile( file.name, 'Het bestand bestaat al.', microtime );
					}).catch( ( err ) => {
						if (
							this.state.acceptedFileTypes.indexOf(file.type) >= 0 &&
							file.size < 2000000
						) {

							let imageRefUpload = imageRef.put(file);

							imageRefUpload.on('state_changed', (snapshot) => {
								let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
								updateTempImage({
									id: microtime,
									progress: progress
								});
							}, (error) => {
								console.log( error );
								rejectedFiles.push(file);
							}, () => {
								this.props.dimensions.map( dimension => {
									console.log( imageRef );

									imageRef.getDownloadURL().then( url => {
										const imageObj = {
											fileName: imageRef.name,
											path: imageRef.fullPath,
											fullSizeUrl: url,
											added: parseInt( microtime )
										};

										app.database().ref( 'cams/images/' + dimension.width + 'x' + dimension.height ).push(imageObj).then( () => {
											removeTempImage({
												id: microtime
											});
											acceptedFiles.push(file);
										});

									})
								})
							});
						} else if ( this.state.acceptedFileTypes.indexOf(file.type) === -1 ) {
							this.rejectFile( file.name, 'Het bestandstype is niet geldig.', microtime );
						} else if ( file.size > 2000000 ) {
							this.rejectFile( file.name, 'Het bestand is te groot', microtime );
						} else {
							this.rejectFile( file.name, 'Onbekende fout', microtime );
						}
					});
				};
			}
		}
	};

	selectItem = (image, event) => {
		const items = document.getElementsByClassName('FileDropZoneDialogDropZoneImage--active');

		while (items.length > 0) {
			items[0].classList.remove('FileDropZoneDialogDropZoneImage--active');
		}

		// if ( items.length > 0 ) {
		// 	items.forEach( ( item ) => {
		// 		item.classList.remove( 'FileDropZoneDialogDropZoneImage--active' );
		// 	});
		// }

		// document.getElementsByClassName( 'FileDropZoneDialogDropZoneImage--active' ).classList.remove( 'FileDropZoneDialogDropZoneImage--active' );
		event.target.classList.add('FileDropZoneDialogDropZoneImage--active');

		this.state = {
			...this.state,
			selectedImage: image,
		};

		// this.setState({
		//
		// });
	};

	selectImage() {
		this.setState({
			...this.state,
			modal: {
				...this.state.modal,
				open: false
			}
		});

		this.props.selectImage(this.state.selectedImage);
	}

	render() {
		const actions = [
			<FlatButton
				label="Annuleren"
				primary={true}
				onClick={this.handleClose}
			/>,
			<FlatButton
				label="Selecteren"
				primary={true}
				keyboardFocused={true}
				onClick={this.selectImage}
			/>,
		];

		// console.log( this.props.images.items[this.props.promotionType] );

		const styles = {
			dropzone: {
				body: {
					height: 'calc(100% - 10px)',
					border: '3px dashed #ccc',
					margin: '10px',
				}
			},
			dialog: {
				content: {
					height: 'calc(100vh - 30px)',
					width: 'calc(100vw - 30px)',
					maxWidth: 'none !important',
					maxHeight: 'none !important',
					transform: 'translate(0, 0) !important',
				},
				body: {
					height: '100%',
					width: '100%',
					maxWidth: 'none !important',
					maxHeight: 'none !important',
					padding: '0'
				}
			}
		};

		return (
			<div>
				<Dialog
					open={this.state.modal.open}
					bodyStyle={styles.dialog.body}
					contentStyle={styles.dialog.content}
					paperClassName="FileDropZoneDialogPaper"
					bodyClassName="FileDropZoneDialogBody"
					actions={actions}
				>
					<div className={ this.state.errors.length > 0 ? 'FileDropZoneDialogErrors' : 'FileDropZoneDialogErrors FileDropZoneDialogErrors--hidden' }>
						De volgende bestanden konden niet worden geüpload

						<ul className="FileDropZoneDialogErrorsList">
							{
								this.state.errors.map( ( error, index ) => {
									return (
										<li key={index}>
											<h3>{error.fileName}</h3>
											<span>{error.message}</span>
										</li>
									)
								})
							}
						</ul>

						<RaisedButton
							label="Ok"
							primary={true}
							onClick={this.removeErrors}
						/>,
					</div>

					<div
						className="FileDropZoneDialogDropZone"
						style={styles.dropzone.body}
						onDrop={this.onDrop}
						// onClick={this.onClick}
						onDragOver={this.onDragOver}
						onDragLeave={this.onDragLeave}
						id="FileDropZoneDialogDropZone"
					>

						{
							this.props.images.tempItems.map((image, key) => {
								return (
									<div key={key} className="FileDropZoneDialogDropZoneImage">
										<div className="FileDropZoneDialogDropZoneImageProgress">
											<div className="FileDropZoneDialogDropZoneImageProgressInner">
												<div className="FileDropZoneDialogDropZoneImageProgressInnerLine" style={{
													width: image.progress + '%'
												}}>
													{image.progress}%
												</div>
											</div>
										</div>
									</div>
								)
							})

						}

						{
							this.props.images.items.sort( (a, b) => {
								if (a.sort < b.sort) {
									return -1;
								} else if (a.sort > b.sort) {
									return 1;
								} else {
									return 0;
								}
							}).reverse().map((image, key) => {
								return (
									<div onClick={this.selectItem.bind(null, image)} key={key} className={undefined !== image.thumbPath ? 'FileDropZoneDialogDropZoneImage' : 'FileDropZoneDialogDropZoneImage FileDropZoneDialogDropZoneImage--optimizing'}>
										{undefined !== image.thumbPath ? <img src={image.thumbPath} /> : <span>Afbeelding wordt geoptimaliseerd</span>}
									</div>
								)
							})
						}
					</div>
				</Dialog>
				<button className={'button secondary'} onClick={this.openModal}>Selecteer Afbeelding</button>
			</div>
		)
	}
}

FileDropZoneDialog.defaultProps = {
	modalOpen: false
};

FileDropZoneDialog.propTypes = {};

const mapStateToProps = (state) => {
	return {
		images: state.images
	}
};

export default connect(mapStateToProps, {
	loadImages,
	resetImages,
	addTempImage,
	updateTempImage,
	removeTempImage
})(FileDropZoneDialog)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/parts/FileDropZoneDialog/index.js